module.exports = __webpack_public_path__ + "static/media/left-tray.033a5fb1.svg";